// extracted by mini-css-extract-plugin
export default {"container":"user-menu_container__3icSW","userWrapper":"user-menu_userWrapper__8xBts","userName":"user-menu_userName__R47q0","fullName":"user-menu_fullName__0mg75"};